import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import '../App.css';

function Projects() {
  const { t } = useTranslation();

  const projects = [
    {
      title: "GoHighlander APP",
      description: t('gohighlander_desc'),
      tags: ["React", "PWA", "Bootstrap"],
      link: "https://ucr.one",
      image: "GoHighlander.jpg",
      logo: "ghlogo.png"
    },
    {
      title: "GoHighlander Website",
      description: t('gohighlander_web_desc'),
      tags: ["React", "Tailwind CSS"],
      link: "https://gohighlander.app",
      image: "ghweb.png",
      logo: "ghlogo.png"
    },
    {
      title: "Kevin Service Registry",
      description: t('ksregistry_desc'),
      tags: ["React", "Tailwind CSS", "Node.js", "Express.js", "MySQL"],
      link: "https://github.com/KevvTheGoat/KS-Subdomain-Registrar",
      image: "ksregistry.jpg",
      logo: "ks.png"
    },
    {
      title: "Kevin Service Free Hosting",
      description: t('ksfreehost_desc'),
      tags: ["React", "Tailwind CSS", "Node.js", "Express.js", "MySQL"],
      link: "https://kevsrv.me",
      image: "ksfreehost.jpg",
      logo: "ks.png"
    },
    {
      title: "QR Code Passkey ODIC Provider",
      description: t('qrcode_passkey_desc'),
      tags: ["React", "Tailwind CSS", "Node.js", "Express.js", "MySQL"],
      link: "",
      image: "odic.jpg",
      logo: "ks.png"
    },
    {
      title: "Vita Global PWA",
      description: t('vita_desc'),
      tags: ["React", "PWA", "Node.js"],
      link: "https://app.chineseunion.org",
      image: "CUAPP.jpg",
      logo: "vita256.png"
    }
  ];

  return (
    <section id="projects" style={{ padding: 'var(--section-spacing) 0' }}>
      <Container>
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          {t('projects')}
        </motion.h2>
        <Row className="justify-content-center">
          {projects.map((project, index) => (
            <Col lg={10} key={index} className="mb-5">
              <motion.div
                className="glass-card"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.8, delay: index * 0.2 }}
                whileHover={{ y: -10 }}
              >
                <Row className="align-items-center">
                  <Col md={5} className="mb-4 mb-md-0 text-center">
                    <motion.div
                      style={{
                        position: 'relative',
                        display: 'inline-block',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        border: '1px solid var(--glass-border)',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.3)'
                      }}
                      whileHover={{ scale: 1.02 }}
                      transition={{ duration: 0.3 }}
                    >
                      <img
                        src={project.image}
                        alt={project.title}
                        style={{
                          maxWidth: '100%',
                          height: 'auto',
                          display: 'block',
                          maxHeight: '500px',
                          objectFit: 'contain'
                        }}
                      />
                    </motion.div>
                  </Col>
                  <Col md={7}>
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <motion.img
                        src={project.logo}
                        alt="logo"
                        width="60"
                        height="60"
                        style={{
                          borderRadius: '12px',
                          boxShadow: '0 4px 10px rgba(0,0,0,0.3)'
                        }}
                        whileHover={{ rotate: 360 }}
                        transition={{ duration: 1 }}
                      />
                      <h3 style={{ fontSize: '2rem', margin: 0 }}>{project.title}</h3>
                    </div>

                    <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem', fontSize: '1.1rem' }}>
                      {project.description}
                    </p>
                    <div className="d-flex flex-wrap gap-2 mb-4">
                      {project.tags.map((tag, i) => (
                        <span key={i} style={{
                          fontSize: '0.9rem',
                          padding: '6px 16px',
                          borderRadius: '20px',
                          background: 'rgba(255,255,255,0.1)',
                          color: 'var(--text-primary)'
                        }}>
                          {tag}
                        </span>
                      ))}
                    </div>
                    <motion.a
                      href={project.link}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-glow"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                      style={{
                        background: 'var(--accent-primary)',
                        color: 'white',
                        padding: '12px 30px',
                        borderRadius: '50px',
                        fontWeight: '600',
                        border: 'none',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '10px'
                      }}
                    >
                      {t('learn_more_btn')} <i className="fa-solid fa-external-link-alt"></i>
                    </motion.a>
                  </Col>
                </Row>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Projects;
